import React from 'react';

import FeedbackIcon from '@atlaskit/icon/core/feedback';
import InformationIcon from '@atlaskit/icon/core/information';

import { token } from '@atlaskit/tokens';

import type { ContentTypesFlagIconString } from '../services/content-types-flag-service-types';

export const ContentTypesFlagIcon = ({
	iconString,
	iconColor,
}: {
	iconString: ContentTypesFlagIconString;
	iconColor: ReturnType<typeof token>;
}) => {
	let IconComponent: React.ElementType;

	switch (iconString) {
		case 'feedback':
			IconComponent = FeedbackIcon;
			break;
		case 'info':
		default:
			IconComponent = InformationIcon;
			break;
	}

	return <IconComponent color={iconColor} label="" />;
};

export const getContentTypesFlagIcon = (
	iconString: ContentTypesFlagIconString,
	iconColor?: ReturnType<typeof token>,
) => <ContentTypesFlagIcon iconString={iconString} iconColor={iconColor ?? token('color.icon')} />;
